var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"form",staticClass:"ml-4",attrs:{"append-icon":"search","label":"Search","clearable":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }